import React, { useCallback } from 'react';

/**
 * Helper hook to create a `processChunk` function that replaces tokens from an array of elements.
 * @param tokens array of elements (PropType.node)
 * @return a function that can be used for the {@link LocalizedMessageDynamic} processChunk prop
 */
const useProcessChunkFromFixedTokens = (tokens = []) => {
    return useCallback(
        ({ isToken, tokenIndex, chunk }) => {
            let result;
            if (isToken) {
                result = tokens[tokenIndex];
            } else {
                result = <React.Fragment key={chunk}>{chunk}</React.Fragment>;
            }
            return result;
        },
        [tokens],
    );
};

export default useProcessChunkFromFixedTokens;
